module.exports = __webpack_public_path__ + "img/Flunder_16.40ef2e98.jpg";